import type { PaperWithRole } from "@/types/paper";

const CSV_COLUMNS: { key: keyof PaperWithRole; header: string }[] = [
  { key: "title", header: "Title" },
  { key: "authors", header: "Authors" },
  { key: "year", header: "Year" },
  { key: "journal", header: "Journal" },
  { key: "doi", header: "DOI" },
  { key: "citations", header: "Citations" },
  { key: "normalized_score", header: "Score" },
  { key: "relevance_score", header: "Raw Score" },
  { key: "methodology_score", header: "Methodology Score" },
  { key: "contribution_type", header: "Contribution Type" },
  { key: "canonical_pdf_status", header: "Full Text Status" },
  { key: "abstract", header: "Abstract" },
  { key: "url", header: "URL" },
];

function escapeCell(value: unknown): string {
  if (value == null) return "";
  const str = Array.isArray(value) ? value.join("; ") : String(value);
  // Escape quotes and wrap if needed
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportPapersToCSV(papers: PaperWithRole[], filename: string): void {
  const header = CSV_COLUMNS.map((c) => c.header).join(",");
  const rows = papers.map((paper) =>
    CSV_COLUMNS.map((col) => escapeCell(paper[col.key])).join(","),
  );
  const csv = [header, ...rows].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
